<template>
  <article>
    <loading-spinner v-if="showSpinner" />
    <div v-else>
      <div v-if="leadActivities.total !== 0">
        <lead-activity-card
          v-for="leadActivity in leadActivities.leads"
          :key="leadActivity.lead.key"
          @click.native="navigateToLead(leadActivity.agent.key, leadActivity.lead.key)"
          :isClickable="isPrincipal"
          :leadActivity="leadActivity"
          :requiresAttention="type === 'Attention'"
          :statusFilter="stateName"
          :gacategory="gacategory"
        />
        <load-more
          v-if="showLoadMore"
          @click.native="getMoreLams(activityFilter, leadActivities.leads.length, type)"
          :active="isLoading"
        />
      </div>
      <div v-else-if="type !== 'Attention'" class="no-data">
        {{ fallbackText }}
      </div>
    </div>
  </article>
</template>

<script>

import { mapState, mapGetters } from 'vuex';
import LeadActivityCard from '@/components/LeadActivityCard.vue';
import LoadingSpinner from '@/components/Animations/LoadingSpinner.vue';
import LoadMore from '@/components/loading/LoadMore.vue';

export default {
  name: 'LeadActivitySection',
  components: {
    LeadActivityCard,
    LoadingSpinner,
    LoadMore,
  },
  props: {
    ak: String,
    leadActivities: { required: true },
    stateName: { required: true },
    isLoading: { default: false },
    hideLoadMore: { default: false },
    type: { default: 'All' },
    gacategory: {default: null}
  },
  computed: {
    ...mapState({
      user: state => state.userStore.user,
    }),
    ...mapGetters('userStore', [
      'isInTestBucket',
      'isPrincipal',
      'isManager',
    ]),
    showSpinner() {
      return this.isLoading === true
        && (!this.leadActivities
        || this.leadActivities.length === 0);
    },
    showLoadMore() {
      return !this.hideLoadMore
        && this.leadActivities.leads
        && this.leadActivities.total !== this.leadActivities.leads.length;
    },
    activityFilter() {
      return this.stateName.replace(' ', '');
    },
    fallbackText() {
      // If this user is not a Principal or they are currently view they own leads
      if (!this.isPrincipal || (this.selectedAgent === this.ak)) {
        return `You currently have no ${this.stateName.toLowerCase()} leads.`;
      }

      // If the leads they are view are not their own
      return `This agent has no ${this.stateName.toLowerCase()} leads.`;
    },
  },
  methods: {
    getMoreLams(statusFilter, offset, leadMode = 'All') {
      const payload = {
        activityType: this.type,
        data: { statusFilter, offset, leadMode },
      };
      this.$emit('load-more-activities', payload);
    },
    navigateToLead(agentKey, LeadKey) {
      console.log('Hello')
      // if ((agentKey === this.ak || this.isInTestBucket) && this.isPrincipal) {
      if (this.isPrincipal) {
        this.$router.push({
          path: `/${agentKey}/lead/${LeadKey}${!!this.user && !!this.user.key ? `/${this.user.key}` : ''}`,
        });
      }
    },
  },
};

</script>

<style scoped lang="scss">
  .agent-filter {
    @apply ut-text-right ut-mr-4;

    @screen md {
      @apply ut-absolute ut-right-0;
    }
  }

</style>
